import { create } from 'zustand';

export type OpenAccountCodeAvailability = {
  accountTypeCode: string;
  accountCode: string;
  isCreateActive: boolean;
  canCreate: boolean;
};

interface OpenAccountAvailabilityState {
  codesAvailability: Array<OpenAccountCodeAvailability>;
  openSpotIsAvailable: boolean;
  openInvestIsAvailable: boolean;
  openMarginIsAvailable: boolean;
  openEarnIsAvailable: boolean;
  spotCreateIsActive: boolean;
  investCreateIsActive: boolean;
  marginCreateIsActive: boolean;
  earnCreateIsActive: boolean;
  setCodesAvailability: (codes: Array<OpenAccountCodeAvailability>) => void;
  resetAvailability: () => void;
}

const someActive = (
  codes: Array<OpenAccountCodeAvailability>,
  accountTypeCode: string
) =>
  codes.some(
    code => code.accountTypeCode === accountTypeCode && code.isCreateActive
  );

const someCanCreate = (
  codes: Array<OpenAccountCodeAvailability>,
  accountTypeCode: string
) =>
  codes.some(
    code => code.accountTypeCode === accountTypeCode && code.canCreate
  );

const useOpenAccountAvailabilityStore = create<OpenAccountAvailabilityState>(
  set => ({
    codesAvailability: [],
    openSpotIsAvailable: false,
    openInvestIsAvailable: false,
    openMarginIsAvailable: false,
    openEarnIsAvailable: false,
    spotCreateIsActive: false,
    investCreateIsActive: false,
    marginCreateIsActive: false,
    earnCreateIsActive: false,
    setCodesAvailability: (codes: Array<OpenAccountCodeAvailability>) =>
      set({
        codesAvailability: codes,
        openSpotIsAvailable: someCanCreate(codes, 'spot'),
        openInvestIsAvailable: someCanCreate(codes, 'invest'),
        openMarginIsAvailable: someCanCreate(codes, 'leverage'),
        openEarnIsAvailable: someCanCreate(codes, 'earn'),
        spotCreateIsActive: someActive(codes, 'spot'),
        investCreateIsActive: someActive(codes, 'invest'),
        marginCreateIsActive: someActive(codes, 'leverage'),
        earnCreateIsActive: someActive(codes, 'earn'),
      }),
    resetAvailability: () =>
      set({
        codesAvailability: [],
        openSpotIsAvailable: false,
        openInvestIsAvailable: false,
        openMarginIsAvailable: false,
        openEarnIsAvailable: false,
        spotCreateIsActive: false,
        investCreateIsActive: false,
        marginCreateIsActive: false,
        earnCreateIsActive: false,
      }),
  })
);

export { useOpenAccountAvailabilityStore };
